<template>
  <div :id="`ticket-expense-${expense.id}`">
    <bookmark-modal modelType="TicketExpense" :modelId="expense.id"
    :currentValue="expense.bookmark"></bookmark-modal>

    <loading-screen :is-loading="isSaving"></loading-screen>

    <div class="card shadow-none">
      <div class="card-body" :class="{ 'pb-0': collapsed }">
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header">
          <div class="tl-l">
            <div class="avatar-xs">
              <span
                class="
                  avatar-title
                  rounded
                  bg-soft-primary
                  text-primary
                  font-size-16
                "
              >
                {{ formatCurrency(expense.currency) }}
              </span>
            </div>
          </div>
          <div class="tl-r">
            <div>
              <span class="name">{{ expense.user ? expense.user.name : 'Unknown' }}</span> added an expense
            </div>
            <small>
              <i>{{ displayTimestamp(expense.created_at) }}</i>
            </small>
          </div>
          <div class="tl-actions">
            <a
              href="#"
              class="btn btn-link text-muted"
              @click.prevent="toggleCollapsed"
            >
              <i
                class="fa"
                :class="{
                  'fa-chevron-down': collapsed,
                  'fa-chevron-up': !collapsed,
                }"
              ></i>
            </a>

            <a href="#" class="btn btn-link text-muted pl-1 pr-1" @click.prevent="openBookmarkModal">
              <i class="fa fa-heart" :class="{
                'text-danger': expense.bookmark
              }"></i>
            </a>

            <b-dropdown
              variant="white"
              right
              toggle-class="text-muted pt-0 pr-0 pb-0"
            >
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item @click="requestDelete" variant="danger"
                >Delete</b-dropdown-item
              >
            </b-dropdown>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <div class="tl-wrapper tl-header" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r">
            <b class="mr-2">Description</b>
            <p>
              {{ expense.description }}
            </p>
          </div>
        </div>
        <!-- / tl-wrapper -->
        <!-- tl-wrapper -->
        <!-- <div class="tl-wrapper" v-show="!collapsed">
          <div class="tl-l"></div>
          <div class="tl-r" v-html="forwardingLog.body"></div>
        </div> -->
        <!-- / tl-wrapper -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Dates from "../../../../../mixins/Dates";
import Forms from "../../../../../mixins/Forms";
import axios from "axios";
import eventBus from "../../../../../event-bus";
import BookmarkModal from './BookmarkModal.vue';
import LoadingScreen from "../../../../../components/LoadingScreen.vue";

export default {
  props: ["expense"],
  name: "TicketExpense",

  data() {
    return {
      collapsed: false,
      isSaving: false
    };
  },

  created() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  updated() {
    eventBus.$on("collapse-all", () => {
      this.collapsed = true;
    });
    eventBus.$on("expand-all", () => {
      this.collapsed = false;
    });
  },

  beforeDestroy() {
    eventBus.$off("collapse-all");
    eventBus.$off("expand-all");
  },

  computed: {
    ...mapGetters("ticketViewer", {
      ticket: "ticket",
    })
  },

  components: {BookmarkModal, LoadingScreen},

  mixins: [Dates, Forms],

  methods: {
    ...mapActions("ticketViewer", {
      loadExpenses: "loadExpenses",
    }),

    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },

    openBookmarkModal() {
      this.$bvModal.show("bookmark-modal-TicketExpense-" + this.expense.id);
    },

    requestDelete() {
      let vm = this;
      swal({
        title: "Are you sure you want to delete this expense?",
        text: "This cannot be undone.",
        icon: "warning",
        buttons: {
          cancel: true,
          confirm: "Delete",
        },
        dangerMode: true,
      }).then((shouldDelete) => {
        if (shouldDelete) {
          vm.delete();
        }
      });
    },

    delete() {
      let vm = this;
      vm.isSaving = true;
      axios
        .delete(
          API_BASE +
            "/tickets/" +
            this.ticket.id +
            "/expenses/" +
            this.expense.id
        )
        .then((r) => {
          vm.isSaving = false;
          vm.loadExpenses();
          this.$notify.success({
            title: "Success!",
            message: "Expense deleted successfully",
          });
        })
        .catch((e) => {
          vm.isSaving = false;
          vm.notifyErrors(e);
        });
    },

    formatCurrency(currency) {
      if (currency === "USD") {
        return "$";
      } else if (currency === "EUR") {
        return "€";
      } else if (currency === "GBP") {
        return "£";
      } else if (currency === "JPY") {
        return "¥";
      } else if (currency == 'AUD') {
        return 'A$';
      } else {
        return currency;
      }
    },
  },
};
</script>

<style scoped>
.card {
  background-image: linear-gradient(#fef1e1, #fef1e1);
}
</style>
